export interface IGetTreatmentDetailsEndpointResponse {
  id: string;
  is_available_website: boolean;
  is_favorite: boolean;
  title: string;
  topics: {
    content: string;
    id: string;
    title: string | null;
  }[];
}

export const getTreatmentDetailsEndpoint = (id: string) => `/treatments/${id}`;
